import { updateObject } from 'utils/updateObject'
import { fromJS } from 'immutable'

const initialState = {
  info: {
    loading: false,
    url: '',
    rules: {},
  },
  list: {
    loading: false,
    data: [],
    pagination: {
      offset: 0,
      limit: 50,
      total: 0,
    },
    sort: {
      prop: 'created_at',
      direction: 'desc',
    },
    query: '',
  },
}

const referralStartLoading = (state, { payload }) =>
  updateObject(state, { [payload]: { ...state[payload], loading: true } })

const referralLoadingFailed = (state, { payload }) =>
  updateObject(state, { [payload]: { ...state[payload], loading: false } })

const referralSetInfo = (state, { payload }) =>
  updateObject(state, { info: { ...state.info, ...payload, loading: false } })

const referralSetList = (state, { payload }) =>
  updateObject(state, {
    list: {
      ...state.list,
      ...payload,
      data: state.list.data.concat(payload.data),
      loading: false,
    },
  })

const referralDropData = (state) =>
  updateObject(state, {
    list: {
      ...state.list,
      data: [],
      pagination: initialState.list.pagination,
    },
  })

const referralSetSorting = (state, { payload }) => {
  const currentList = fromJS(state.list)
  const updatedList = currentList.setIn(['sort'], payload).toJS()
  return updateObject(state, { list: updatedList })
}

const referralSetQuery = (state, { payload }) => {
  const currentList = fromJS(state.list)
  const updatedList = currentList.setIn(['query'], payload).toJS()
  return updateObject(state, { list: updatedList })
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'REFERRAL/START_LOADING':
      return referralStartLoading(state, action)
    case 'REFERRAL/LOADING_FAILED':
      return referralLoadingFailed(state, action)
    case 'REFERRAL/SET_INFO':
      return referralSetInfo(state, action)
    case 'REFERRAL/SET_LIST':
      return referralSetList(state, action)
    case 'REFERRAL/SET_SORTING':
      return referralSetSorting(state, action)
    case 'REFERRAL/SET_QUERY':
      return referralSetQuery(state, action)
    case 'REFERRAL/DROP_DATA':
      return referralDropData(state, action)
    default:
      return state
  }
}

export default reducer
